module.exports = __webpack_public_path__ + "img/kzq-icon.252f8aae.png";